import { ProductizedServiceWorkWithMe_productizedService$key } from '#app/__generated__/relay/ProductizedServiceWorkWithMe_productizedService.graphql.js';
import { type ProductizedServiceWorkWithMe_userProfile$key } from '#app/__generated__/relay/ProductizedServiceWorkWithMe_userProfile.graphql.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { useNavigation } from '#app/hooks/useNavigation.js';
import { useProductizedServicePreview } from '#app/hooks/useProductizedServicePreview.js';
import { ServiceInquiryButton } from '../ServiceInquiryButton/ServiceInquiryButton.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 0;

    ${theme.mediaQueries.lg} {
      padding: 16px 0;
    }
  `}
`;

const Buttons = styled.div`
  display: flex;
  gap: 16px;
`;

type ProductizedServiceWorkWithMeProps = {
  readonly canBuyNow: boolean;
  readonly productizedServiceRef: ProductizedServiceWorkWithMe_productizedService$key;
  readonly slug: string;
  readonly userProfileRef: ProductizedServiceWorkWithMe_userProfile$key;
};

export const ProductizedServiceWorkWithMe = ({
  canBuyNow,
  productizedServiceRef,
  slug,
  userProfileRef,
}: ProductizedServiceWorkWithMeProps) => {
  const isMobile = useIsMobile();
  const userProfile = useFragment<ProductizedServiceWorkWithMe_userProfile$key>(
    graphql`
      fragment ProductizedServiceWorkWithMe_userProfile on UserProfile {
        generalInquiryCtaIsVisible
      }
    `,
    userProfileRef,
  );
  const navigation = useNavigation();

  const service =
    useFragment<ProductizedServiceWorkWithMe_productizedService$key>(
      graphql`
        fragment ProductizedServiceWorkWithMe_productizedService on ProductizedService {
          ...useProductizedServicePreview_productizedService
          ...ServiceInquiryButton_productizedService
        }
      `,
      productizedServiceRef,
    );

  const { isPreview } = useProductizedServicePreview(service);

  if (!userProfile.generalInquiryCtaIsVisible) {
    return null;
  }

  return (
    <Container aria-label="work with me section">
      <Text textStyle={isMobile ? 'fifthLevelHeadline' : 'thirdLevelHeadline'}>
        Work with me
      </Text>
      <Buttons>
        {canBuyNow ? (
          <Button
            disabled={isPreview}
            onClick={() =>
              navigation.push(
                getRoute('/s/@slug/checkout', {
                  args: {
                    slug,
                  },
                }),
              )
            }
          >
            {' '}
            Buy service
          </Button>
        ) : null}
        <ServiceInquiryButton
          buttonVariant={canBuyNow ? 'V2Secondary' : 'V2Gradient'}
          productizedServiceRef={service}
          section="work_with_me"
        />
      </Buttons>
    </Container>
  );
};
